// test1695
(1695 && 0);
